import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, history } from 'redux/store';
// import { AnalyticsProvider } from 'providers/analyticsProvider';
import App from './App';
import * as serviceWorker from './serviceWorker';

require('dotenv').config();

if (process.env.REACT_APP_DEPLOY_ENV === 'PROD' && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
  for (const [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value === 'function' ? () => {} : null;
  }
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      {/* <AnalyticsProvider> */}
      <App />
      {/* </AnalyticsProvider> */}
    </Router>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
